/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetAllergiesErrorResponse,
  GetAllergiesParams,
  GetAllergiesResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getAllergies = (params?: GetAllergiesParams, signal?: AbortSignal) => {
  return api<GetAllergiesResponse>({ url: `/api/allergies`, method: 'GET', params, signal });
};

export const getGetAllergiesQueryKey = (params?: GetAllergiesParams) => {
  return [`/api/allergies`, ...(params ? [params] : [])] as const;
};

export const getGetAllergiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllergies>>,
  TError = GetAllergiesErrorResponse,
>(
  params?: GetAllergiesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllergies>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllergiesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllergies>>> = ({ signal }) =>
    getAllergies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllergies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllergiesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllergies>>>;
export type GetAllergiesQueryError = GetAllergiesErrorResponse;

export function useGetAllergies<
  TData = Awaited<ReturnType<typeof getAllergies>>,
  TError = GetAllergiesErrorResponse,
>(
  params: undefined | GetAllergiesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllergies>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllergies>>,
          TError,
          Awaited<ReturnType<typeof getAllergies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllergies<
  TData = Awaited<ReturnType<typeof getAllergies>>,
  TError = GetAllergiesErrorResponse,
>(
  params?: GetAllergiesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllergies>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllergies>>,
          TError,
          Awaited<ReturnType<typeof getAllergies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllergies<
  TData = Awaited<ReturnType<typeof getAllergies>>,
  TError = GetAllergiesErrorResponse,
>(
  params?: GetAllergiesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllergies>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAllergies<
  TData = Awaited<ReturnType<typeof getAllergies>>,
  TError = GetAllergiesErrorResponse,
>(
  params?: GetAllergiesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllergies>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllergiesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
